import React from 'react'

import {
    SyncOutlined,
    AimOutlined
} from '@ant-design/icons';
import { Button, Input, InputNumber, Modal, Divider, Card, Space, Select, notification } from 'antd';
import { isFgLeader, isBoardMember, updateFgApproval } from '../util/APIUtils';
const { Option } = Select;

export default function FgActionButtons(props) {
    const [visible, setVisible] = React.useState(false);
    const [action, setAction] = React.useState("");
    const [description, setDescription] = React.useState("");
    const [amount, setAmount] = React.useState(0);
    const [fgStatus, setFgStatus] = React.useState("");
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const [fgLeader, setFgLeader] = React.useState(false);
    const [boardMember, setBoardMember] = React.useState(false);
    const fgBudgetInfo = props.fgBudgetInfo
    const cropId = props.fgBudgetInfo.cropId;
    const breederId = props.fgBudgetInfo.breederId;

    console.log(cropId);
    console.log(breederId)

    console.log(fgBudgetInfo)

    const isUserFgLeader = () => {
        let promise;
        promise = isFgLeader(cropId);

        if (!promise) {
            return;
        }

        promise.then(response => {
            setFgLeader(response)

        }).catch(error => {
            console.log(error)
        });
    }

    const isUserBoardMember = () => {
        let promise;
        promise = isBoardMember();

        if (!promise) {
            return;
        }
        promise.then(response => {
            setBoardMember(response);

        }).catch(error => {
            console.log(error)
        });
    }

    React.useEffect(() => {
        isUserFgLeader();
        isUserBoardMember();
    }, [isUserFgLeader, isUserBoardMember]);


    const handleOk = () => {
        setConfirmLoading(true);
        let workFlowResponse = {
            itemId: fgBudgetInfo.id,
            comment: description,
            approvedAmount: amount,
            fgStatus: fgStatus,
            approverType: action
        }

        console.log(workFlowResponse)
        let promise;
        promise = updateFgApproval(workFlowResponse);

        if (!promise) {
            return;
        }

        promise.then(response => {
            setConfirmLoading(false);
            setVisible(false);
            props.reload();

        }).catch(error => {
            console.log(error)
        });
    };

    const handleCancel = () => {
        setVisible(false);
    };

    const approveClicked = (action) => {
        setVisible(true);
        setAction(action);
    }

    const getNextActionFromStatus = () => {
        let breederAccess = breederId === props.currentUser.breederInfo.id
        console.log(breederAccess)
        console.log(fgBudgetInfo.nextAction)
        console.log(boardMember)
        switch (fgBudgetInfo.nextAction) {
            case 'BREEDER':
                return breederAccess ? <Button type="primary" style={{ display: 'inline-block', verticalAlign: 'middle' }} onClick={() => approveClicked("BREEDER")} >Einreichen</Button> : ""
            case 'FG':
                return fgBudgetInfo.isFgLeader ? <Button type="primary" style={{ verticalAlign: 'middle' }} onClick={() => approveClicked("FG")} >FG Evaluation</Button> : ""
            case 'BOARD':
                return boardMember ? <Button type="primary" style={{ display: 'inline-block', verticalAlign: 'middle' }} onClick={() => approveClicked("BOARD")} >Board Evaluation</Button> : ""
            case 'REPORT-ACTUAL':
                return null
        }
    }

    return (
        <div style={{ padding: '15px', background: '#ececec' }}>
            <Card bordered={false} >
                <Modal
                    title={action.toUpperCase() + " - Kommentar"}
                    visible={visible}
                    onOk={handleOk}
                    confirmLoading={confirmLoading}
                    onCancel={handleCancel}
                // afterClose={onExit}
                >
                    {['FG', 'BOARD'].includes(fgBudgetInfo.nextAction) ?
                        <span>
                            <Space>
                                Betrag
                                <InputNumber value={amount} onChange={setAmount} />
                                <br></br>
                                Status
                                <Select style={{ width: 120 }} onChange={(val) => setFgStatus(val)} defaultValue={1}>
                                    <Option value={1} >Ok</Option>
                                    <Option value={-1}>Zurückgestellt</Option>
                                    <Option value={0}>Abgelehnt</Option>
                                </Select>
                            </Space>
                            <Divider /></span> : ""}
                    Kommentar
                    <Input.TextArea value={description} onChange={e => setDescription(e.target.value)} rows={7} />
                </Modal>
                {getNextActionFromStatus()}
            </Card>
        </div>
        // </div>
    )
}
